import { EmailVerificationScreen } from "@components/Onboarding/EmailVerificationScreen";

export default function VerifyEmailScreen() {
  return <EmailVerificationScreen />;
}
